module.exports = __webpack_public_path__ + "static/img/collegeAddress.76eb74a1.ad613b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/collegeAddress.76eb74a1.png
// module id = O/Gq
// module chunks = 1